
import { useMemo } from 'react';
import { useValidationYupDocumento } from 'views/components/form-validations';
import * as Yup from 'yup';
import { AnyObject } from 'yup/lib/types';

export const useFormGerenteCadastroValidation = () => {

  const { documentoYup } = useValidationYupDocumento(false)

  const FormGerenteEdicaoValidationYup = useMemo(() => {
    return Yup.object().shape<AnyObject>({
      nomeComercial: Yup.string().required('O nome comercial é obrigatório.'),
      cpfCnpj: documentoYup(),
    });
  }, [documentoYup])

  return {
    FormGerenteEdicaoValidationYup,
  }
}